import './Home.css';

const Home = () => {
  return (
    <section className='home container'>
      <div className='home-wrapper'>
        <h2 className='home-header'>
          <span className='lancaster-color'>Llamadas</span> de
        </h2>
        <h2 className='home-header'>Cobranza con</h2>
        {/* <h2 className='home-header'>
          <span className="whatsapp-color">WhatsApp</span><br />
          <span className="facebook-color">Facebook</span><br />
          <span className="instagram-color">Instagram</span>
        </h2> */}
        <h2 className='type-header'>
          <span className='lancaster-color'>Inteligencia Artificial</span>
        </h2>
        <p className='home-paragraph'>
          <span>Lancaster automatiza <span className='lancaster-color'>llamadas con Inteligencia Artificial.</span></span> <br />
          <span>Te genera <span className='lancaster-color'>reportes y seguimiento</span> dentro de tu CRM.</span> <br />
          <span>Conecta llamadas, agenda y seguimiento en <span className='lancaster-color'>un solo flujo de trabajo.</span></span> <br />
        </p>
        <div className='home-actions'>
          <a
            href="/"
            className='work-with-us-button'
            onClick={(e) => {
              e.preventDefault();
              if (window.location.pathname === '/') {
                let element = document.getElementById('ourteam_section');
                element &&
                  element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                  });
              } else {
                window.location.href = '/#ourteam_section';
              }
            }}>
            ¡Contáctanos!
          </a>
        </div>
      </div>
    </section>
  );
};

export default Home;
